module.exports = __webpack_public_path__ + "static/media/pami.439246b5.png";